export default "__VITE_ASSET__o4YdR_dT__"